import debounce from "../helpers/debounce";

class HomeHero {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.videoContainer = self.elem.querySelector('[data-home-hero-video-container]');
        self.videoAspectRatio = getComputedStyle(self.elem).getPropertyValue("--home-hero-video-aspect-ratio");
        self.videoWidth = self.videoAspectRatio.split("/")[0];
        self.videoHeight = self.videoAspectRatio.split("/")[1];
    }

    init() {
        let self = this;
        
        self.setVideoOrientation();

        const resizeDebounce = debounce(function (msg) {
            self.setVideoOrientation();
        });

        window.addEventListener('resize', evt => {
            resizeDebounce('debounced');
        });
    }

    setVideoOrientation() {
        let self = this;

        if((self.getHeroWidth() / self.getHeroHeight()) >= (self.videoWidth / self.videoHeight)) {
            // the video container is MORE landscape than the video
            self.videoContainer.classList.add('is-landscape');
            self.videoContainer.classList.remove('is-portrait');
        } else {
            // the video container is LESS landscape than the video
            self.videoContainer.classList.add('is-portrait');
            self.videoContainer.classList.remove('is-landscape');
        }
    }

    getHeroWidth() {
        let self = this;

        const rect = self.elem.getBoundingClientRect();
        return rect.width;
    }

    getHeroHeight() {
        let self = this;

        const rect = self.elem.getBoundingClientRect();
        return rect.height;
    }
}

export default HomeHero;
